// @internal
import React, { useContext } from 'react';
import { Icon, IconProps } from '../../../Icon/Icon';
import { SideNavContext } from '../../SideNavContext';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { StyledSideNavIcon, StyledSideNavIconBadge } from './styles';

export type SideNavIconProps = {
  /** Icon type */
  icon?: IconProps['type'];
  /** Badged state modifier */
  isBadged?: boolean;
  /** Active state modifier */
  isActive?: boolean;
  /** Simple description for screen readers */
  meaning?: string;
  /** Marks the element with a given ID to make it easier to select it on tests */
  'data-testid'?: string | number;
};

const SideNavIcon = ({ icon, isBadged, isActive = false, meaning, 'data-testid': dataTestId }: SideNavIconProps) => {
  const { isClosed } = useContext(SideNavContext);
  const globalProps = getGlobalProps({});

  return (
    <StyledSideNavIcon isClosed={isClosed} isActive={isActive} {...globalProps} data-testid={dataTestId}>
      <Icon size="lg" type={icon} aria-hidden={isClosed ? 'false' : 'true'} meaning={meaning} />
      <StyledSideNavIconBadge
        data-testid={dataTestId ? `${dataTestId}-badge` : ''}
        isClosed={isClosed}
        isBadged={isBadged}
        aria-hidden="true"
      />
    </StyledSideNavIcon>
  );
};

SideNavIcon.displayName = 'SideNav.Icon';

export default SideNavIcon;
